import React from 'react';

const  CheckerListIcon = ({ checkColor = '', circleColor = '#fff', size, styles }) => (
    <svg width="23" height="25" viewBox="0 0 23 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.150391 0.148438H15.5452V3.98438H19.1975V7.60126H17.4975V5.68437H5.50273V23.1532H17.4975V18.2412H19.1975V24.8532H3.80273V21.0173H0.150391V0.148438ZM13.8452 1.84844V3.98438H3.80273V19.3173H1.85039V1.84844H13.8452ZM13.3444 19.4569L22.2866 10.59L21.0896 9.38281L13.3592 17.0482L9.22537 12.8474L8.01367 14.0398L13.3444 19.4569Z" fill="white"/>
    </svg>
    
);

export default CheckerListIcon;
